import { useMemoizedFn } from 'ahooks';
import { useChatPageStore } from '@/features/chat-messages/store';
import { getSupplierAgentGlobalState } from '@/stores/supplier-agent-global-store';
import { IApiSessionEmailExpandReq } from '@/services/swagger/easourcing/models';
import { emailExpandPost } from '@/services/swagger/easourcing/SessionService';
import { toast } from '@leadsnavi/ui-kit';
/**
 * 获取消息回话中，ai 生成的邮箱内容
 */
export const getMessageEmailContent = async (params: IApiSessionEmailExpandReq) => {
  return await emailExpandPost({
    sessionId: params.sessionId,
    messageId: params.messageId,
    subMessageId: params.subMessageId,
  })
    .then(res => {
      return res.data?.emailContent || '';
    })
    .catch(() => {
      toast.error('Failed to get email content');
      return '';
    });
};

export const useSupplierAgentActions = () => {
  const askEmailWrite = useChatPageStore(store => store.askEmailWrite);

  /**
   * 触发 AI 写信：
   * 1. 打开 AI agent 侧弹窗
   * 2. 调用 askEmailWrite 发送写信请求
   */
  const handleAiEmailWrite = useMemoizedFn(async () => {
    // 打开 AI agent 侧弹窗
    getSupplierAgentGlobalState().setAgentSidebarOpen(true);
    // 调用写信接口
    await askEmailWrite();
  });

  return {
    handleAiEmailWrite,
  };
};
